// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shipping_processing_body = /** @type {(inputs: {}) => string} */ () => {
	return `Orders are processed within 1-2 business days. You will receive a confirmation email once your order has been dispatched.`
};

const el_shipping_processing_body = /** @type {(inputs: {}) => string} */ () => {
	return `Οι παραγγελίες επεξεργάζονται εντός 1-2 εργάσιμων ημερών. Θα λάβετε email επιβεβαίωσης μόλις αποσταλεί η παραγγελία σας.`
};

const ru_shipping_processing_body = /** @type {(inputs: {}) => string} */ () => {
	return `Заказы обрабатываются в течение 1-2 рабочих дней. Вы получите электронное письмо с подтверждением после отправки заказа.`
};

const he_shipping_processing_body = /** @type {(inputs: {}) => string} */ () => {
	return `הזמנות מעובדות תוך 1-2 ימי עסקים. תקבלו אימייל אישור ברגע שההזמנה נשלחה.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_processing_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_processing_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_processing_body", locale)
	if (locale === "en") return en_shipping_processing_body(inputs)
	if (locale === "el") return el_shipping_processing_body(inputs)
	if (locale === "ru") return ru_shipping_processing_body(inputs)
	if (locale === "he") return he_shipping_processing_body(inputs)
	return "shipping_processing_body"
};